export default __webpack_public_path__ + "static/64883250-0-pc-home-page-words1-e84b08735a0c8f3e9b54643b7ded37c9.gif";